import React from 'react';
import Button from '../Common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

interface UnlockImageProps {
  submit?: () => void;
}

const UnlockImage: React.FC<UnlockImageProps> = ({ submit }) => {
  return (
    <div className="unlock-image" style={{
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      padding: '2rem',
      textAlign: 'center',
      zIndex: 5
    }}>
      <FontAwesomeIcon icon={faLock} className=" text-4xl text-storyerror mb-4" />
      <h1 className="text-2xl text-storyblue font-bold mb-4">Unlock Image</h1>
      <p className="text-md text-storyblue">Continue creating your book and ship it to your door!</p>
      <Button
        title="Finish Your Story"
        onClick={submit}
        className="bg-storyerror flex  text-white font-sans font-bold rounded-2xl px-4 py-2 text-xs m-4  h-8 w-[120px] justify-center"
      />
    </div>
  );
};

export default UnlockImage;
